import { connect } from 'react-redux';
import BroadbandCompareTrackingPixel from '../../components/tracking/BroadbandCompare/BroadbandCompareTrackingPixel';

const mapStateToProps = state => ({
  trackingId: state.success.trackingId
});

const BroadbandCompareTrackingPixelContainer = connect(mapStateToProps)(BroadbandCompareTrackingPixel);

export default BroadbandCompareTrackingPixelContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/BroadbandCompareTrackingPixelContainer.js
 **/